module.exports = __webpack_public_path__ + "static/media/iconeechographie.080994fc.png";